import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load';
import get from 'lodash.get';

import styles from './styles/FollowingCarouselItem.scss';

const getImage = item => get(item, 'photos[0].versions[0].webPath');

const OFFSET_IMAGE_VERTICAL = 0;
const OFFSET_IMAGE_HORIZONTAL = 0;

export const FollowingCarouselItem = props => {
    const { item, onContentVisible, onItemClick } = props;
    return (
        <a
            className={styles.itemLink}
            href={item.pdpURL}
            onClick={onItemClick}
            data-tn={`item-id-${item.serviceId}`}
        >
            <LazyLoad
                offsetHorizontal={OFFSET_IMAGE_HORIZONTAL}
                offsetVertical={OFFSET_IMAGE_VERTICAL}
                onContentVisible={onContentVisible}
            >
                <img className={styles.image} src={getImage(item)} />
            </LazyLoad>
        </a>
    );
};

FollowingCarouselItem.propTypes = {
    item: PropTypes.object.isRequired,
    onItemClick: PropTypes.func,
    onContentVisible: PropTypes.func,
};

FollowingCarouselItem.defaultProps = {
    onItemClick: () => {},
    onContentVisible: () => {},
};
